import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';

export const orTestimonialBlockMockData = {
  autoPlay: true,
  cards: [
    {
      headline: 'What our new homeowners are saying:',
      _metadata: {
        uid: 'cs123456789abcdef',
      },
      images: [
        {
          entry_title: 'Image 1',
          _metadata: {
            uid: 'csimage1',
          },
          alt: 'Happy homeowner',
          mobile_image_url: '/assets/image_card.jpg',
          tablet_image_url: '/assets/image_card.jpg',
          desktop_image_url: '/assets/image_card.jpg',
        },
      ],
      quote:
        'Buying our home was a dream come true! The process was smooth, and the end result is absolutely stunning. We love every inch of our new home.',
      cta: {
        label: "Emily & James' Story",
        href: '/',
        variant: EClickableVariants.DIMINUTIVE,
        target: '_self',
        underline: false,
        outline: false,
        size: null,
        icon: [],
      },
    },
    {
      headline: 'What our new homeowners are saying:',
      _metadata: {
        uid: 'cs987654321fedcba',
      },
      images: [
        {
          entry_title: 'Image 1',
          _metadata: {
            uid: 'csimage2a',
          },
          alt: 'Family moving in',
          mobile_image_url: '/assets/image_card.jpg',
          tablet_image_url: '/assets/image_card.jpg',
          desktop_image_url: '/assets/image_card.jpg',
        },
        {
          entry_title: 'Image 2',
          _metadata: {
            uid: 'csimage2b',
          },
          alt: 'Living room interior',
          mobile_image_url: '/assets/home_plan.jpeg',
          tablet_image_url: '/assets/home_plan.jpeg',
          desktop_image_url: '/assets/home_plan.jpeg',
        },
      ],
      quote:
        'The design process was seamless, and our home was built to perfection. We couldn’t be happier with how it turned out!',
      cta: {
        label: "Sarah & Tom's Story",
        href: '/',
        variant: EClickableVariants.DIMINUTIVE,
        target: '_self',
        underline: false,
        outline: false,
        size: null,
        icon: [],
      },
    },
    {
      headline: 'What our new homeowners are saying:',
      _metadata: {
        uid: 'csabcdef123456789',
      },
      images: [
        {
          entry_title: 'Image 1',
          _metadata: {
            uid: 'csimage3',
          },
          alt: 'Happy couple in new home',
          mobile_image_url: '/assets/home_plan.jpeg',
          tablet_image_url: '/assets/home_plan.jpeg',
          desktop_image_url: '/assets/home_plan.jpeg',
        },
      ],
      quote:
        'From the first consultation to move-in day, we felt taken care of. This home is exactly what we envisioned, and we love every detail!',
      cta: {
        label: "David's Story",
        href: '/',
        variant: EClickableVariants.DIMINUTIVE,
        target: '_self',
        underline: false,
        outline: false,
        size: null,
        icon: [],
      },
    },
  ],
};
